var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsScheduling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 14.6667C6.27781 14.6667 4.78337 14.0944 3.5167 12.95C2.25003 11.8056 1.53337 10.3778 1.3667 8.66667H2.7167C2.88337 10.0111 3.46948 11.125 4.47503 12.0083C5.48059 12.8917 6.65559 13.3333 8.00003 13.3333C9.48892 13.3333 10.75 12.8167 11.7834 11.7833C12.8167 10.75 13.3334 9.48889 13.3334 8C13.3334 6.51111 12.8167 5.25 11.7834 4.21667C10.75 3.18334 9.48892 2.66667 8.00003 2.66667C7.04448 2.66667 6.15837 2.90278 5.3417 3.375C4.52503 3.84722 3.87781 4.5 3.40003 5.33334H5.33337V6.66667H1.4667C1.78892 5.11111 2.56114 3.83334 3.78337 2.83334C5.00559 1.83334 6.41114 1.33334 8.00003 1.33334C8.92226 1.33334 9.78892 1.50834 10.6 1.85834C11.4111 2.20834 12.1167 2.68334 12.7167 3.28334C13.3167 3.88334 13.7917 4.58889 14.1417 5.4C14.4917 6.21111 14.6667 7.07778 14.6667 8C14.6667 8.92222 14.4917 9.78889 14.1417 10.6C13.7917 11.4111 13.3167 12.1167 12.7167 12.7167C12.1167 13.3167 11.4111 13.7917 10.6 14.1417C9.78892 14.4917 8.92226 14.6667 8.00003 14.6667ZM9.8667 10.8L7.33337 8.26667V4.66667H8.6667V7.73334L10.8 9.86667L9.8667 10.8Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsScheduling);
export default __webpack_public_path__ + "static/media/icons-scheduling.9d0b2ee0.svg";
export { ForwardRef as ReactComponent };